module.exports = __webpack_public_path__ + "img/1582830568.73b8b48f.jpg";